import { useTranslation } from "react-i18next";

export interface CartLinesSkeletonProps {
  /** Tantas filas fantasma como líneas guardadas. */
  count?: number;
}

/**
 * Lo que se ve mientras el CATÁLOGO viaja.
 *
 * El carrito sabe al instante QUÉ hay dentro —está en `localStorage`—
 * pero no cuánto cuesta ni cómo se llama: eso lo resuelve el catálogo del
 * servidor. Ese hueco de tiempo existe de verdad la primera vez que se
 * abre el panel en una ficha recién cargada.
 *
 * Filas fantasma del mismo alto que las reales, no un spinner centrado:
 * cuando llegan los datos, el subtotal del pie no da un salto.
 */
export function CartLinesSkeleton({ count = 2 }: CartLinesSkeletonProps) {
  const { t } = useTranslation();

  return (
    <div role="status" aria-busy="true" className="grid gap-4 px-5 py-4">
      <span className="sr-only">{t("Cargando el carrito…")}</span>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          aria-hidden="true"
          className="flex animate-pulse gap-4 motion-reduce:animate-none"
        >
          <div className="h-20 w-20 shrink-0 rounded-ds-md bg-ds-mist/60" />
          <div className="flex-1 space-y-2 py-1">
            <div className="h-3 w-3/4 rounded-ds-sm bg-ds-mist/60" />
            <div className="h-3 w-1/3 rounded-ds-sm bg-ds-mist/60" />
            <div className="h-8 w-28 rounded-ds-pill bg-ds-mist/60" />
          </div>
        </div>
      ))}
    </div>
  );
}
